<template>
  <div :class="[$style.icon, $style[fillClass], $style[bgClass]]" class="mt-icon mt-icon-ok" />
</template>

<script type="text/ecmascript-6">
import iconsMixins from './../icons.mixins'

export default {
  name: 'OkIcon',

  mixins: [iconsMixins],

  data () {
    return {
      defaultStatusFill: {
        icon: 'white',
        bg: 'blue'
      }
    }
  }
}
</script>

<style lang="scss" module>
@import 'mpl-css/lib/assets/global/variables/colors';
@import 'mpl-css/lib/assets/global/functions/index';
@import 'mpl-css/lib/assets/global/icons/icons-colors';

@import 'mpl-css/lib/assets/global/icons/icons-svg';

.icon {
  position: relative;
  width: rem(28);
  height: rem(28);
  border-radius: 50%;
  &::before {
    background-size: 60% 60%;
  }
}

@each $color, $value in $colors {
  .bg#{$color} {
    background-color: map-get($colors, $color);
  }
  .fill#{$color} {
    $ok-fill: encodeHexColor(map-get($colors, $color));
    $okIcon: getIconPngUrl('ok', $ok-fill);
    &::before {
      background-image: url($okIcon);
    }
    &:hover,
    &:active {
      &::before {
        background-image: url($okIcon);
      }
    }
  }
}
</style>
